import { useMutation } from "react-query";
import { updateApps } from "../../Mutation/Apps/AppsMutation";

export const useAppsummaryConfigurationMutation = () => {
  return useMutation(
    async ({ appId, data }) => {
      const updateAppSummary = await updateApps({ app: appId, ...data });
      return updateAppSummary;
    },
    {
      retry: 3,
    }
  );
};
